// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Kufam:ital,wght@0,400..900;1,400..900&family=Playwrite+AU+SA:wght@100..400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Kufam', serif;
  font-optical-sizing: auto;
}

body {
  background-color: #1d1c1c;
}

/* navigation */
nav {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 30px;
  background-color: #e60303b7;
  gap: 2px;
}

nav .logo {
  font-size: 30px;
  font-weight: 700;
  color: #000;
}

#logo {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  background-color: #ff6347;
}

nav .nav-links {
  margin-left: 100px;
  display: flex;
  gap: 60px;
}

nav a:hover {
  color: rgb(255, 255, 255);
  border-radius: 0.7rem;
}

a {
  text-decoration: none;
  color: #000;
  font-size: 18px;
  font-weight: 500;
  transition: all 0.3s ease;
}

#content {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  padding: 40px;
  min-height: calc(100vh - 70px);
  flex-wrap: wrap;
}

/* homepage */
#dish {
  width: 550px;
  height: 550px;
  margin: 70px;
  border-radius: 20px;
  object-fit: cover;
}

.textcont {
  max-width: 500px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
}

h2,
p,
h1,
h3,
h5 {
  color: #fff;
}

h2 {
  font-size: 2rem;
  margin-bottom: 10px;
}

.textcont p {
  font-size: 1.05rem;
  line-height: 1.7;
  color: #ccc;
}

/* aboutpage */
.about-text {
  max-width: 500px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-right: 40px;
}

.about-text h1 {
  font-size: 2.5rem;
}

.about-text p {
  font-size: 1.05rem;
  line-height: 1.8;
  color: #ccc;
}

.about-img img {
  width: 450px;
  height: 500px;
  border-radius: 20px;
  object-fit: cover;
}

/* menupage */
.menu-card {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #2a2a2a;
  border-radius: 16px;
  overflow: hidden;
  width: 750px;
  height: 300px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
  transition: transform 0.3s ease;
}

.menu-card:hover {
  transform: translateY(-4px);
}

.menu-img {
  width: 220px;
  height: 300px;
  object-fit: cover;
  flex-shrink: 0;
}

.menu-info {
  padding: 20px 28px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.menu-info h3 {
  font-size: 1.3rem;
  color: #ff6347;
}

.menu-info p {
  font-size: 0.95rem;
  color: #bbb;
  line-height: 1.6;
}

.menu-info h5 {
  font-size: 1.1rem;
  color: #e60303;
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Kufam:ital,wght@0,400..900;1,400..900&family=Playwrite+AU+SA:wght@100..400&display=swap');\r\n\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n  font-family: 'Kufam', serif;\r\n  font-optical-sizing: auto;\r\n}\r\n\r\nbody {\r\n  background-color: #1d1c1c;\r\n}\r\n\r\n/* navigation */\r\nnav {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 8px 30px;\r\n  background-color: #e60303b7;\r\n  gap: 2px;\r\n}\r\n\r\nnav .logo {\r\n  font-size: 30px;\r\n  font-weight: 700;\r\n  color: #000;\r\n}\r\n\r\n#logo {\r\n  width: 50px;\r\n  height: 50px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n  background-color: #ff6347;\r\n}\r\n\r\nnav .nav-links {\r\n  margin-left: 100px;\r\n  display: flex;\r\n  gap: 60px;\r\n}\r\n\r\nnav a:hover {\r\n  color: rgb(255, 255, 255);\r\n  border-radius: 0.7rem;\r\n}\r\n\r\na {\r\n  text-decoration: none;\r\n  color: #000;\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n#content {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: #fff;\r\n  padding: 40px;\r\n  min-height: calc(100vh - 70px);\r\n  flex-wrap: wrap;\r\n}\r\n\r\n/* homepage */\r\n#dish {\r\n  width: 550px;\r\n  height: 550px;\r\n  margin: 70px;\r\n  border-radius: 20px;\r\n  object-fit: cover;\r\n}\r\n\r\n.textcont {\r\n  max-width: 500px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n  justify-content: center;\r\n}\r\n\r\nh2,\r\np,\r\nh1,\r\nh3,\r\nh5 {\r\n  color: #fff;\r\n}\r\n\r\nh2 {\r\n  font-size: 2rem;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.textcont p {\r\n  font-size: 1.05rem;\r\n  line-height: 1.7;\r\n  color: #ccc;\r\n}\r\n\r\n/* aboutpage */\r\n.about-text {\r\n  max-width: 500px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n  padding-right: 40px;\r\n}\r\n\r\n.about-text h1 {\r\n  font-size: 2.5rem;\r\n}\r\n\r\n.about-text p {\r\n  font-size: 1.05rem;\r\n  line-height: 1.8;\r\n  color: #ccc;\r\n}\r\n\r\n.about-img img {\r\n  width: 450px;\r\n  height: 500px;\r\n  border-radius: 20px;\r\n  object-fit: cover;\r\n}\r\n\r\n/* menupage */\r\n.menu-card {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  background-color: #2a2a2a;\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n  width: 750px;\r\n  height: 300px;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.menu-card:hover {\r\n  transform: translateY(-4px);\r\n}\r\n\r\n.menu-img {\r\n  width: 220px;\r\n  height: 300px;\r\n  object-fit: cover;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.menu-info {\r\n  padding: 20px 28px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.menu-info h3 {\r\n  font-size: 1.3rem;\r\n  color: #ff6347;\r\n}\r\n\r\n.menu-info p {\r\n  font-size: 0.95rem;\r\n  color: #bbb;\r\n  line-height: 1.6;\r\n}\r\n\r\n.menu-info h5 {\r\n  font-size: 1.1rem;\r\n  color: #e60303;\r\n  font-weight: 700;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
